export var MainGroupConfiguration;
(function (MainGroupConfiguration) {
    MainGroupConfiguration["None"] = "None";
    MainGroupConfiguration["Sport"] = "Sport";
    MainGroupConfiguration["League"] = "League";
    MainGroupConfiguration["Day"] = "Day";
    MainGroupConfiguration["Event"] = "Event";
})(MainGroupConfiguration || (MainGroupConfiguration = {}));
//# sourceMappingURL=MainGroupConfiguration.js.map